//@ts-check
import validator from './validator';
import fileLabel from './fileLabel';
var xmlElementInvalidChars = ['~', '`', '@', '&', '=', '[', ']', '{', '}', '\'', ','];

var shouldNotStartWithXml = function shouldNotStartWithXml(value) {
  if (value && value.substring(0, 3).toLocaleLowerCase() === 'xml') return 'Form name cannot start with the letters xml';
  return undefined;
};
/**@type {import("./types").FormFieldValidator} */


export default (function (value) {
  var error = validator.shouldBeSpecified(value);
  if (error) return error;
  error = validator.shouldHaveMaxLength(value, 128);
  if (error) return error;
  error = fileLabel(value);
  if (error) return error;
  error = validator.shouldStartWithALetterOrUnderscore(value);
  if (error) return error;
  error = shouldNotStartWithXml(value);
  if (error) return error;
  error = validator.shouldNotContainChars(value, xmlElementInvalidChars);
  if (error) return error;
  return undefined;
});